<template>
<div id="contentWrap">
  <div class="content right">
    <div id="content_1block" class="right">
      <div id="content_top">
        <div class="content_title_full right">بازسازی رمز عبور</div>
      </div>
      <div class="pure-form pure-form-aligned">
        <fieldset style="margin-right: 80px;">

          <div class="pure-control-group" style="line-height: 50px;">
            <label for="password">بازسازی رمز عبور</label>
            <input id="password" class="pure-input-2-3" type="password" placeholder="رمز عبور" v-model="strPsw">
          </div>

          <div class="pure-control-group" style="line-height: 50px;">
            <label for="confirm_password">تایید رمز عبور</label>
            <input id="confirm_password" class="pure-input-2-3" type="password" placeholder="تایید رمز عبور" v-model="strConfirmPsw">
          </div>

          <div class="pure-controls" style="margin-right: 230px;">
            <button type="reset" value="Reset" class="button-warning pure-button pure-button-primary" style="width: 160px;" @click="cancel()">لغو</button>
            <button type="submit" class="button-warning pure-button pure-button-primary" style="width: 160px;" @click="confirm()">بازسازی رمز عبور</button>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
</div>
</template>
<script>
/*jshint esversion: 6 */
import {
  getDataUrl
} from '../../tools/getUrl.js';
import router from '../../router.js';
export default {
  data: function() {
    return {
      strPsw: '',
      strConfirmPsw: ''
    };
  },
  methods: {
    confirm: function() {
      if (this.strPsw === this.strConfirmPsw) {
        var obj = {
            api: 'modify_account',
            email: this.$route.params.email,
            passwd: this.strPsw
          },
          url = getDataUrl(obj);
        this.$http.get(url).then((response) => {
          // success callback
          var datums = response.data;
          if (datums > 0) {
            alert('رمز عبور  شما تغییر داده شد.');
            router.push('/');
          } else {

          }
        }, (response) => {
          // error callback
        });
      } else {

      }
    },
    cancel: function() {
      router.push('/');
    }
  },
  mounted() {
    // console.log(this.$route.params.email);
  }
};
</script>



// WEBPACK FOOTER //
// Resetpsw.vue?394bc5a6